import { COLORS } from '@btime/constants'
import { capitalizeIfLower } from '@btime/helpers'
import { compose, pathOr, curry, path } from 'ramda'
import React from 'react'

import { Text } from '../../../../components/presentation/Text'
import { getPlaceIcon } from '../../../places/_context/PlaceTypeContext'
import FlexGrid, { FlexColumn } from '../../../../components/structure/FlexGrid'
import IconText from '../../../../components/presentation/IconText'
import Panel from '../../../../components/structure/Panel'
import Separator from '../../../../components/helpers/Separator'
import DeletedTag from '../../../../components/helpers/DeletedTag'
import DateText from '../../../../components/presentation/DateText'

const capitalizePath = curry((capFunc, fields, item) => compose(capFunc, pathOr('', fields))(item))

const AssetCard = ({ item }) => {
  const assetName = capitalizePath(capitalizeIfLower, ['name'], item)
  const placeName = capitalizePath(capitalizeIfLower, ['place', 'name'], item)
  const placeType = path(['place', 'type'], item)
  const typeName = capitalizePath(capitalizeIfLower, ['type', 'name'], item)

  return (
    <Panel smallPadding>
      <FlexGrid justify="flex-start" gutter={0.3}>
        <Text bold size="h3" color={COLORS.dark3}>
          {assetName}
        </Text>
        <DeletedTag entity={item} />
        <FlexColumn flex={1}>
          <DateText
            size="xsmall"
            bold
            align="right"
            color={COLORS.dark3}
            date={item.insertedAt}
            format="DD/MM/YYYY HH:mm"
          />
        </FlexColumn>
      </FlexGrid>

      <Separator weight={4} />

      {!!placeName && (
        <IconText
          left
          color={COLORS.dark3}
          iconName={getPlaceIcon(placeType)}
          label={placeName}
          iconSize="1rem"
          size="p"
          separatorWeight={3}
        />
      )}

      {!!typeName && (
        <IconText
          left
          color={COLORS.dark3}
          iconName="BsTag"
          label={typeName}
          iconSize="1rem"
          size="p"
          separatorWeight={3}
        />
      )}
    </Panel>
  )
}

export default AssetCard
